import { Divider, styled } from '@mui/material';
import { color } from '@/colors';

const AppDivider = styled(Divider)({
  borderColor: color.White08_T,
});

export default AppDivider;
